// reading_progress 저장소 (기획서 7.4, 9.3)
// 위치는 globalOffset 이 유일한 진실, percent 는 fallback. 파생값 비저장 (0.6).
import { idbGet, idbPut, idbWriteWithRetry } from './schema.js';

export function makeInitialProgress(bookId, format) {
  return {
    bookId,
    position: {
      cfi: null,
      globalOffset: format === 'txt' ? 0 : null,
      percent: 0,
    },
    progress: 0,
    bookmarks: [],
    updatedAt: Date.now(),
  };
}

export async function getProgress(bookId) {
  return idbGet('reading_progress', bookId);
}

/**
 * 위치 저장 (기획서 9.3).
 * TXT: { globalOffset, percent } / EPUB: { cfi, percent }. percent 항상 채움.
 * chunkIndex·페이지 번호는 저장하지 않음 (0.6).
 * 실패해도 throw 하지 않고 false 반환 — 호출부가 메모리 보관 후 재시도 (12.3).
 */
export async function saveProgress(bookId, { cfi = null, globalOffset = null, percent }) {
  try {
    const prev = (await getProgress(bookId)) || makeInitialProgress(bookId, 'txt');
    const next = {
      ...prev,
      position: { cfi, globalOffset, percent },
      progress: percent,
      updatedAt: Date.now(),
    };
    await idbWriteWithRetry(() => idbPut('reading_progress', next));
    return true;
  } catch (err) {
    console.warn('[progress] 저장 실패, 다음 주기 재시도:', err);
    return false;
  }
}

export async function saveProgressRecord(record) {
  return idbWriteWithRetry(() => idbPut('reading_progress', record));
}
